/**
 * Model operation terminology constants
 * Maps backend operation types and statuses to user-friendly display text
 */

// Operation type display names
export const OPERATION_DISPLAY_NAMES = {
  experiment: 'Test',
  quick_train: 'Test', // Changed from 'Quick Train' to 'Test'
  train: 'Train'
} as const;

// Operation type action names (present tense)
export const OPERATION_ACTION_NAMES = {
  experiment: 'Testing',
  quick_train: 'Testing', // Changed from 'Quick Training' to 'Testing'
  train: 'Training'
} as const;

// Operation type past tense names
export const OPERATION_PAST_TENSE_NAMES = {
  experiment: 'Tested',
  quick_train: 'Tested', // Changed from 'Quick Trained' to 'Tested'
  train: 'Trained'
} as const;

// Version status display names
// Maps backend status values to user-friendly display text
export const VERSION_STATUS_DISPLAY = {
  draft: 'draft',
  experimenting: 'testing', // Maps 'experimenting' status to 'testing'
  experimented: 'tested', // Maps 'experimented' status to 'tested'
  training: 'training',
  trained: 'trained',
  published: 'published'
} as const;

// Button labels
export const OPERATION_BUTTON_LABELS = {
  experiment: 'Experiment',
  quick_train: 'Run Test', // Changed from 'Quick Train' to 'Run Test'
  train: 'Train'
} as const;

// Tooltip text
export const OPERATION_TOOLTIPS = {
  experiment: 'Analyze your components, score them, and show how they relate to each other (less than a minute)',
  quick_train: 'Analyze your components, score them, and show how they relate to each other. Also scores your model and gives backtest results (five to ten minutes)', // Will update if needed
  quick_train_with_changes: (count: number) =>
    `${count} change${count !== 1 ? 's' : ''} detected - test recommended`,
  train: 'Train and backtest your model using your components (several hours)'
} as const;

// Helper function to get display name for operation type
export function getOperationDisplayName(type: string): string {
  return OPERATION_DISPLAY_NAMES[type as keyof typeof OPERATION_DISPLAY_NAMES] || type;
}
  
// Helper function to get action name for operation type
export function getOperationActionName(type: string): string {
  return OPERATION_ACTION_NAMES[type as keyof typeof OPERATION_ACTION_NAMES] || type;
}

// Helper function to get past tense name for operation type
export function getOperationPastTenseName(type: string): string {
  return OPERATION_PAST_TENSE_NAMES[type as keyof typeof OPERATION_PAST_TENSE_NAMES] || type;
}

// Helper function to get display name for version status
export function getVersionStatusDisplay(status: string): string {
  return VERSION_STATUS_DISPLAY[status as keyof typeof VERSION_STATUS_DISPLAY] || status;
}